import React from 'react';
import { cloneObject } from '../../../common/utils';

const PseudoElement = React.forwardRef((props, ref) => {
  const { children } = props;
  const elementAttributes = cloneObject(props, {}, [
    'type',
    'isLinkExternal',
    'children',
    'disabled',
    'href',
    'title',
    'to',
    'isLinkExternal'
  ]);

  return <div {...elementAttributes} ref={ref}>{children}</div>;
});

export default PseudoElement;